import * as React from 'react';

import {Stack} from '../../layout/stack/stack';
import {PopoverForm} from '../../popover-form/popover-form';
import {SelectPickerGeneric} from '../../select-picker-generic/select-picker-generic';
import {TextField} from '../../textfield/textfield';
import {Body} from '../../typography/body';

export type DelayOptions = {
    value: string;
    label: string;
};

type Props = {
    delayOptions: Array<DelayOptions>;
    delayDuration: string;
    delayReason: string;
    onDurationChange: (duration: string) => void;
    onReasonChange: (reason: string) => void;
    onSubmit: () => void;
    onClose: () => void;
};

export function TaskDelayForm(props: Props) {
    return (
        <PopoverForm
            title='Delay this task'
            onSubmit={props.onSubmit}
            onClose={props.onClose}
            saveButtonVariant='save'
            saveButtonText='Delay this task'
        >
            <div className='pb-16'>
                <Stack spacing={8}>
                    <SelectPickerGeneric
                        options={props.delayOptions}
                        // @ts-expect-error
                        onChange={(option) => {
                            props.onDurationChange(option.value);
                        }}
                        value={props.delayOptions.find(
                            (option) => option.value === props.delayDuration
                        )}
                        isSearchable={false}
                        minHeight={34}
                    />
                    <Body isBold={true}>Reason:</Body>
                    <TextField value={props.delayReason} onChange={props.onReasonChange} />
                </Stack>
            </div>
        </PopoverForm>
    );
}
